/* global swal, _, angular*/
import './style.less';

export default function($log, $q, $element, RegulatorClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  let formDataTemp = false;

  vm.$doCheck = () => {
    if (!vm.loaded || !vm.ngModel || vm.ngModel.selected || angular.equals(vm.ngModel.formData, formDataTemp)) return;
    buildBasic();
    formDataTemp = angular.copy(vm.ngModel.formData);
    vm.ngChange();
  };

  function buildBasic() {
    const hours_basic = {};

    vm.ngModel.formData.modifiedStates.forEach(state => (hours_basic[state.reg_id] = state.hours));

    vm.ngModel.hours_basic = hours_basic;
  }

  function buildStates(cert) {
    cert.formData = cert.formData || {};
    cert.formData.states = [];
    cert.formData.modifiedStates = [];
    cert.selected = cert.selected || false;
    Object.assign([], vm.states).forEach(({ state, name, reg_id, hours }) => {
      if (cert.hours_basic && cert.hours_basic[reg_id]) {
        return cert.formData.modifiedStates.push({ state, name, reg_id, hours: cert.hours_basic[reg_id] });
      }
      cert.formData.states.push({ state, name, reg_id, hours });
    });

    formDataTemp = angular.copy(cert.formData);
    return cert;
  }

  function activate() {
    $log.debug('Advanced Options Component Activated');
    vm.loaded = false;
    vm.error = {};

    vm.toggle = false;

    RegulatorClass.loadRegulators()
      .then(({ arrCurrent: regulators }) => {
        $log.debug('Advanced Options Component Data', arguments);

        vm.states = [];

        Object.assign([], regulators).forEach(({ name, reg_id, state, cycle_template }) => {
          const hours = Object.keys(Object.assign({}, cycle_template)).map(category => ({ category, credits: 0 }));
          vm.states.push({ state, name, reg_id, hours });
        });

        buildStates(vm.ngModel);

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: error.status, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/advancedOptions/controller.js